import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-status-change-reason-dialog',
  templateUrl: './status-change-reason-dialog.component.html',
  styleUrls: ['./status-change-reason-dialog.component.css']
})
export class StatusChangeReasonDialogComponent implements OnInit {

  readonly otherReasonName = 'Other';

  public title = 'Card Status Change';
  public text = '';
  public subText = '';
  public confirm = 'Confirm';
  public cancel = 'Cancel';
  public selectableReasons: string[] = [];
  public customReasonAllowed = false;

  selectedReason: string;
  reasonText: string;

  constructor(
    public dialogRef: MatDialogRef<StatusChangeReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if (this.data != null) {
      this.title = this.data.title || this.title;
      this.text = this.data.text || this.text;
      this.subText = this.data.subText || this.subText;
      this.cancel = this.data.cancel || this.cancel;
      this.confirm = this.data.confirm || this.confirm;
      this.selectableReasons = this.data.selectableReasons || this.selectableReasons;
      this.customReasonAllowed = this.data.customReasonAllowed ?? this.customReasonAllowed;
    }

    if (this.customReasonAllowed) {
      this.selectableReasons.push(this.otherReasonName)
      if ( this.selectableReasons.length === 1 )
        this.selectedReason = this.otherReasonName;
    }
  }

  showCustomReasonInput(): boolean {
    return this.customReasonAllowed && this.selectedReason == this.otherReasonName
  }

  isYesDisabled(): boolean {
    return !this.selectedReason || this.selectedReason == this.otherReasonName && !this.reasonText;
  }

  onYesClick(): void {
    this.dialogRef.close(this.showCustomReasonInput() ? this.reasonText : this.selectedReason);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
